import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";

const options = [
  { label: "NA", value: "NA" },
  { label: "No", value: "No" },
  { label: "Yes", value: "Yes" },
];

export const electronicRecord: FieldSchema = {
  grid: {
    displayed: false,
    order: 20,
    sortable: false,
    ignoredForSearch: true,
  },
  name: "electronicRecord",
  data: {
    active: false,
    variant: DataVariants.ENUM,
    options,
  },
  display: {
    displayed: true,
  },
  form: {
    label: "Electronic Records (ER)?",
    type: InputTypes.SELECT,
    displayed: false,
    disabled: true,
  },
};
